import { render, staticRenderFns } from "./LocationUpdateForm.vue?vue&type=template&id=0af7b1de&scoped=true&"
import script from "./LocationUpdateForm.vue?vue&type=script&lang=ts&"
export * from "./LocationUpdateForm.vue?vue&type=script&lang=ts&"
import style0 from "./LocationUpdateForm.vue?vue&type=style&index=0&id=0af7b1de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af7b1de",
  null
  
)

export default component.exports